var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractPlaceModal',_vm._g({key:_vm.state.type,attrs:{"value":_vm.isModalOpen,"placeEntity":_vm.placeEntity,"strategy":_vm.strategy},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var onClose = ref.onClose;
return [_c('DialogTitleHeader',{attrs:{"text":_vm.headerText},on:{"click":onClose}})]}}])},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }